import axios from 'axios';

export function getUserScreenRevenue(token, userId, screenId) {
    return axios.post(
        `${process.env.REACT_APP_API_URL}/getUserScreenRevenue`,
        { userId, screenId },
        { headers: { Authorization: `${token}` } },
    );
}
